import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(unauthenticated)/published/v1/swimlane')({
  loader: async () => {
    // In the future, we'll load the published link data here
    return {};
  },
});
